import type {
  AccessGrant,
  AccessGrantSource,
  AccessPrincipal,
  AccessPrincipalType,
  AccessRole,
} from '~/features/access-control/types/AccessControl';

export type ServerAccessGrant = {
  principal: {
    type: AccessPrincipalType;
    id: string;
    name: string;
    email?: string;
  };
  role: AccessRole;
  source: AccessGrantSource;
  source_name?: string;
  is_owner?: boolean;
  read_only?: boolean;
};

export type ServerAccessPrincipalRef = {
  type: AccessPrincipalType;
  id: string;
};

export type ServerResourceAccess = {
  grants: ServerAccessGrant[];
  inherit_from_parent: boolean;
};

export type ResourceAccess = {
  grants: AccessGrant[];
  inheritFromParent: boolean;
};

function mapServerGrant(grant: ServerAccessGrant): AccessGrant {
  return {
    principal: grant.principal,
    role: grant.role,
    source: grant.source,
    sourceName: grant.source_name,
    isOwner: grant.is_owner,
    readOnly: grant.read_only,
  };
}

export function mapGrantToServer(grant: AccessGrant): ServerAccessGrant {
  return {
    principal: grant.principal,
    role: grant.role,
    source: grant.source,
    source_name: grant.sourceName,
    is_owner: grant.isOwner,
    read_only: grant.readOnly,
  };
}

export function mapPrincipalToServerRef(
  principal: AccessPrincipal,
): ServerAccessPrincipalRef {
  return { type: principal.type, id: principal.id };
}

export function mapResourceAccessResponse(
  serverResponse: ServerResourceAccess,
): ResourceAccess {
  return {
    grants: serverResponse.grants.map(mapServerGrant),
    inheritFromParent: serverResponse.inherit_from_parent,
  };
}
